import React, { useEffect, useState } from "react";

import { signinAdminUser } from "services";

import { clearLocalKlimVar, getEnvironment, incomplete, useCancelAsyncOnUnmount, useToggleNavs } from "utils";

import { Button, Col, Form, Input, InputPassword, Link, MainPage, Row, Tooltip, Typography } from "components";

import { AccountLogo } from "pages/app/account/components/AccountLogo";

export const SignIn = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSignInConfirmed, setIsSignInConfirmed] = useState(false);
  const signal = useCancelAsyncOnUnmount()();

  const env = getEnvironment();

  useToggleNavs(false, false);

  const complete = (v) => {
    setIsLoading(true);
    signinAdminUser({
      ...v,
      ...{ signal },
    })
      .then((res) => {
        clearLocalKlimVar("token");

        if (env.local && res.link) {
          window.location.href = res.link;
        } else if (res.success) {
          setIsSignInConfirmed(true);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    clearLocalKlimVar("token");
  }, []); // eslint-disable-line

  const SignInForm = () => (
    <div>
      <Row>
        <Col>
          <Typography variant="paragraph-m" className="margin-bottom-0">
            After you have signed in, you will receive an email to continue. If you have never been granted admin access or have not accessed it in 3 months,{" "}
            <b>please request admin access below</b> (currently disabled and under construction).
          </Typography>
        </Col>
      </Row>
      <Form name="signin" className="margin-top-300" onFinish={(v) => complete(v)} onFinishFailed={(v) => incomplete(v)}>
        <Row>
          <Col>
            <Input
              name="email"
              label="Email"
              rules={[
                {
                  required: true,
                  type: "email",
                },
              ]}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <InputPassword name="password" label="Password" rules={[{ required: true }]} />
          </Col>
        </Row>
        <Row className="margin-bottom-200">
          <Col>
            <Link to="/password">Forgot your password?</Link>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Item>
              <Button type="primary" htmlType="submit" disabled={isLoading} loading={isLoading}>
                Sign in
              </Button>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Item>
              <Tooltip title="Currently under construction" style={{ display: "flex" }}>
                <Button type="secondary" href="/admin-request" disabled={true} loading={isLoading}>
                  Request admin access
                </Button>
              </Tooltip>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );

  return (
    <MainPage pageName={"sign-in-up"}>
      <Row className="mini-form">
        <Col>
          <AccountLogo />
          <Row>
            <Col>
              <Typography variant="h1">Admin sign in</Typography>
            </Col>
          </Row>
          {!isSignInConfirmed ? (
            <SignInForm />
          ) : (
            <Row>
              <Col>
                <Typography variant="paragraph-m" className="margin-bottom-0">
                  Please check your emails.
                </Typography>
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    </MainPage>
  );
};
